<template>
  <div>
    <ts-page-title
      :title="$t('examEvaluationList.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('examEvaluationList.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper>
        <div class="row">
          <div class="col-lg-3">
            <div class="card border-0 bg-gray-900">
              <div class="card-body">
                <div class="text-gray-500">
                  <b>{{ $t("examEvaluationList.criteria") }}</b>
                </div>
              </div>
              <div class="widget-list rounded-bottom tw-space-y-4">
                <div class="col-md-12 tw-mt-4 tw-space-y-2">
                  <label class="form-col-label control-label">{{
                    $t("examEvaluationList.branch")
                  }}</label>
                  <ts-branch-filter
                    @filter="(value) => (model.branch_id = value)"
                  />
                  <div class="invalid-feedback" v-if="errors.has('branch_id')">
                    {{ errors.first("branch_id") }}
                  </div>
                </div>
                <div class="col-md-12 tw-space-y-2 tw-mt-3">
                  <label class="form-col-label control-label">{{
                    $t("examEvaluationList.courseSkill")
                  }}</label>
                  <a-select
                    :placeholder="$t('all')"
                    class="col-md-12"
                    show-search
                    mode="multiple"
                    option-filter-prop="children"
                    allowClear
                    :loading="waiting"
                    v-model="model.courseSkill"
                    :class="{
                      'is-invalid': errors.has('courseSkill'),
                    }"
                  >
                    <a-select-option
                      v-for="(courseSkill, index) in formViewDatas[
                        'courseSkills'
                      ]"
                      :key="index"
                      :value="courseSkill.course_skill_id"
                    >
                      {{ courseSkill.examination_event }}
                    </a-select-option>
                  </a-select>
                  <div
                    class="invalid-feedback"
                    v-if="errors.has('courseSkill')"
                  >
                    {{ errors.first("courseSkill") }}
                  </div>
                </div>
                <div class="col-md-12 tw-space-y-2">
                  <label class="form-col-label control-label required">{{
                    $t("examEvaluationList.date")
                  }}</label>
                  <a-range-picker
                    v-model="model.dateRange"
                    :allowClear="false"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    style="width: 100%"
                    @change="onChangeDate"
                  />
                  <div class="invalid-feedback" v-if="errors.has('dateRange')">
                    {{ errors.first("dateRange") }}
                  </div>
                </div>
                <div class="col-md-12 tw-space-y-2">
                  <label
                    class="form-col-label control-label required tw-w-full"
                    >{{ $t("examRegistrationList.reportType") }}</label
                  >
                  <a-radio-group
                    v-model="model.reportType"
                    :default-value="1"
                    class="tw-w-full"
                  >
                    <a-radio-button class="tw-w-1/2 tw-text-center" :value="1">
                      Detail
                    </a-radio-button>
                    <a-radio-button class="tw-w-1/2 tw-text-center" :value="2">
                      Summary
                    </a-radio-button>
                  </a-radio-group>
                  <div class="invalid-feedback" v-if="errors.has('reportType')">
                    {{ errors.first("reportType") }}
                  </div>
                </div>
                <div class="mb-3 tw-justify-end tw-flex tw-space-x-2">
                  <ts-button
                    color="danger"
                    outline
                    @click.prevent="preview"
                    :waiting="waiting"
                  >
                    <i class="far fa-file-pdf" v-if="!waiting"></i>
                    {{ $t("previewPdf") }}</ts-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-9">
            <div id="container">
              <ts-preview-pdf v-model="waiting" :src="src" />
            </div>
          </div>
        </div>
      </ts-panel-wrapper>
    </ts-panel>
  </div>
</template>

<script>
import { Errors } from "form-backend-validation";
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { debounce } from "lodash";

export default {
  name: "examEvaluationList",
  data() {
    return {
      waiting: false,
      exporting: false,
      errors: new Errors(),
      src: "",
      model: {
        branch_id: [],
        courseSkill: [],
        reportType: 1,
        dateRange: [
          moment().add(-7, "days").format("DD-MM-YYYY"),
          moment().format("DD-MM-YYYY"),
        ],
      },
    };
  },
  computed: {
    ...mapState("report/report", ["edit_data", "formViewDatas"]),
  },
  methods: {
    ...mapActions("report/report", ["getFormViewData"]),
    async fetchFormViewModel() {
      this.waiting = true;
      await this.getFormViewData({
        index: "courseSkills",
        params: {
          fnName: "courseSkills",
          branch_id: this.model.branch_id,
        },
      });
      this.waiting = false;
    },
    preview() {
      this.errors = new Errors();
      this.waiting = true;
      this.src = "";
      this.$store
        .dispatch("report/report/examEvaluationList", this.model)
        .then((response) => {
          this.src = response.url;
        })
        .catch((error) => {
          this.errors = new Errors(error.errors);
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          this.waiting = false;
        });
    },
    onChangeDate(dateRange) {
      this.model.dateRange = dateRange[0] && dateRange[1] ? dateRange : [];
    },
  },
  watch: {
    "model.branch_id": debounce(function () {
      this.fetchFormViewModel();
    }, 500),
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     vm.fetchFormViewModel();
  //   });
  // },
};
</script>
